module.exports = __webpack_public_path__ + "img/syukyaku-top-pa002sp.66b90366.png";